import { Injectable } from "@angular/core";
import { RequestLibraryService } from "@service/core/request-library.service";

/**
 * Unibox API client.
 *
 * RequestLibraryService.toHttpParams JSON.stringifies EVERY query value. Flat
 * string params therefore become quoted (filter=%22all%22) and `undefined`
 * becomes the literal search string "undefined" — which made staging Unibox
 * show 0 threads. Wrap list args in MO's standard `options` JSON blob instead.
 *
 * Always send filter (default all) so BE sanitizeListOpts never falls back to
 * unanswered on a missing key during first-paint races.
 */
@Injectable()
export class UniboxService {
  constructor(private requestLibrary: RequestLibraryService) {}

  getThreads(opts: any = {}) {
    const clean: any = {};
    let filter =
      opts.filter != null && String(opts.filter).trim() !== ""
        ? String(opts.filter).trim()
        : "all";
    if (filter === "undefined" || filter === "null") {
      filter = "all";
    }
    clean.filter = filter;
    clean.channel = opts.channel || "all";
    if (opts.page != null && opts.page !== "") {
      clean.page = opts.page;
    }
    if (opts.page_size != null && opts.page_size !== "") {
      clean.page_size = opts.page_size;
    }
    if (opts.automation_id != null && opts.automation_id !== "") {
      clean.automation_id = opts.automation_id;
    }
    const q = opts.q != null ? String(opts.q).trim() : "";
    if (q && q !== "undefined" && q !== "null") {
      clean.q = q;
    }
    return this.requestLibrary.GetAll("/unibox/threads", { options: clean });
  }

  getThread(threadKey: string, enrollmentId?: number) {
    const q: any = {};
    if (enrollmentId) {
      q.enrollment_id = enrollmentId;
    }
    // enrollment_id is numeric — JSON.stringify(5) === "5" (safe as flat param)
    return this.requestLibrary.GetAll(
      "/unibox/threads/" + encodeURIComponent(threadKey),
      q
    );
  }

  reply(threadKey: string, body: any) {
    return this.requestLibrary.Post(
      "/unibox/threads/" + encodeURIComponent(threadKey) + "/reply",
      body
    );
  }

  markRead(threadKey: string) {
    return this.requestLibrary.Post(
      "/unibox/threads/" + encodeURIComponent(threadKey) + "/read",
      {}
    );
  }
}
